// extracted by mini-css-extract-plugin
module.exports = {"title":"DescriptionListItemTitle-title-1Y38p"};